import { PageCollectionConfigLanguage } from '@creator-suite/page-types';
import {
  NEXT_PUBLIC_ROOT_DOMAIN,
  NEXT_PUBLIC_ROOT_DOMAIN_LEGACY,
} from './envs-client';

export const getPrefixPath = (host: string, domain: string) => {
  const apex = host.replace('www.', '');
  if (
    apex === NEXT_PUBLIC_ROOT_DOMAIN ||
    apex === NEXT_PUBLIC_ROOT_DOMAIN_LEGACY
  ) {
    return '/~/' + domain;
  }

  return '';
};

/**
 * Returns the complete URL for the privacy policy.
 *
 * @param language - The language, either 'de' or 'en'
 * @param prefixPath - A prefix to be prepended to the path if no external URL is provided
 * @param externalPrivacyPolicyUrl - An optional external URL override
 * @returns The URL string for the privacy policy
 */
export const getPrivacyPolicyUrl = (
  language: PageCollectionConfigLanguage,
  prefixPath: string,
  externalPrivacyPolicyUrl?: string,
): string => {
  const path =
    language === PageCollectionConfigLanguage.DE
      ? '/datenschutz'
      : '/en/privacy-policy';
  return externalPrivacyPolicyUrl || `${prefixPath}${path}`;
};

/**
 * Returns the complete URL for the imprint.
 *
 * @param language - The language, either 'de' or 'en'
 * @param prefixPath - A prefix to be prepended to the path if no external URL is provided
 * @param externalImprintUrl - An optional external URL override
 * @returns The URL string for the imprint
 */
export const getImprintUrl = (
  language: PageCollectionConfigLanguage,
  prefixPath: string,
  externalImprintUrl?: string,
): string => {
  const path =
    language === PageCollectionConfigLanguage.DE ? '/impressum' : '/en/imprint';
  return externalImprintUrl || `${prefixPath}${path}`;
};

/**
 * Returns the complete URL for the consent manager.
 *
 * @param language - The language, either 'de' or 'en'
 * @param prefixPath - A prefix to be prepended to the path if no external URL is provided
 * @param externalConsentManagerUrl - An optional external URL override
 * @returns The URL string for the consent manager
 */
export const getConsentManagerUrl = (
  language: PageCollectionConfigLanguage,
  prefixPath: string,
  externalConsentManagerUrl?: string,
): string => {
  const path =
    language === PageCollectionConfigLanguage.DE
      ? '/de/consent-manager'
      : '/en/consent-manager';
  return externalConsentManagerUrl || `${prefixPath}${path}`;
};

export const AppPageRouteSettingsMembers = {
  getPath: () => '/~/settings/members',
};

export const AppPageRouteSettingsAddress = {
  getPath: () => '/~/settings/address',
};

export const AppPageRouteOtp = {
  getPath: (language: 'de' | 'en') => `/${language}/otp`,
};
